// src/Redux/api/apiSlice.js - NO CHANGES NEEDED HERE
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery"; // Your custom axios wrapper

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: axiosBaseQuery({
    // Make sure you pass the base query function
    baseUrl: process.env.REACT_APP_API_BASE_URL + "/api/",
  }),
  tagTypes: [
    "DayTour",
    "User",
    "Driver",
    "DriverFormDependencies",
    "DestinationList",
    "Role",
    "Permission",
    "Cooperator",
    "CooperatorFormDependencies",
    "Tourguide",
    "CityListForForms",
    "TourLabel",
    "RoomCategory",
    "Accommodation",
    "AccommodationFormDependencies",
    "StopSale",
    "TransportationPrice",
    "TransportationType",
    "TourguidePrice",
    "TourProfit",
    "TourOffer",
    "TourOfferFormDependencies",
    "LeadStatus",
    "Campaign",
    "ColdCampaign",
    "Lead",
    "Package",
    "PackageTitle",
    "Amenity",
    "Reservation",
    "TravelAgency",
    "Country",
    "Service",
    "Notification",
  ],
  endpoints: (builder) => ({}),
});
